import React from 'react';
import Navbar from '../components/Navbar';
import './Refund.css';

function Refund() {
    return (
        <div className="page-container refund-page">
            <Navbar />

            <section className="refund-hero">
                <div className="container">
                    <div className="refund-hero-content">
                        <span className="section-badge">POLÍTICA</span>
                        <h1 className="refund-title">
                            Términos de <span className="gradient-text">Reembolso</span>
                        </h1>
                        <p className="refund-subtitle">
                            Última actualización: 19 de marzo de 2026
                        </p>
                    </div>
                </div>
            </section>

            <section className="refund-content">
                <div className="container">
                    <div className="refund-wrapper">
                        <div className="refund-section">
                            <h2>Política de reembolso</h2>
                            <p>
                                Gracias por utilizar la plataforma "Habla con Krishna". Valoramos tu compromiso con el crecimiento espiritual y nos esforzamos por brindarte la mejor experiencia en nuestro sitio.
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>Productos intangibles e irrevocables ("Productos digitales")</h2>
                            <p>
                                No realizamos reembolsos por productos intangibles e irrevocables ("Productos digitales") una vez confirmado el pedido y enviado el producto.
                            </p>
                            <p>
                                Nuestros servicios principales incluyen el acceso a conversaciones sagradas guiadas por IA y contenido espiritual. Debido a la naturaleza digital de estos productos, no es posible "devolverlos" una vez que se ha otorgado el acceso.
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>Soporte y ayuda</h2>
                            <p>
                                Si tienes problemas para recibir servicios, acceder al chat o dificultades técnicas, te recomendamos que te pongas en contacto con nuestro equipo de soporte.
                            </p>
                            <p>
                                Nuestro equipo hará todo lo posible para que tu viaje espiritual sea continuo y significativo.
                            </p>
                        </div>

                        <div className="refund-section">
                            <h2>Contacto</h2>
                            <p>Si tienes preguntas sobre la política de reembolso, ponte en contacto con nosotros:</p>
                            <ul>
                                <li>Email: <a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a></li>
                                <li>Sitio web: <a href="/contact">Formulario de contacto</a></li>
                            </ul>
                        </div>

                        <div className="refund-footer-note">
                            <p>
                                <strong>Compromiso espiritual:</strong> Al realizar una compra, confirmas y aceptas los términos de esta política.
                                Te agradecemos sinceramente por ser parte de la familia "Habla con Krishna".
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Refund;
